// export const assets = {
//   inv: require("./inv-bg.jpeg"),
//   goldFlower: require("./gold-flower.png"),
//   hexagonFrame: require("./hexagon-frame.png"),
//   frameWithFlower: require("./frame-with-flower.png"),
//   frameWithFlower2: require("./frame-with-flower2.png"),
//   borderFlower: require("./border-flower.png"),
//   frame: require("./frame.png"),
//   frame1: require("./frame1.png"),
//   pattern: require("./pattern.png"),
//   strokeGold: require("./stroke-gold.png"),
//   frameBrushGold: require("./frame-brush-gold.png"),
//   blackTexture1: require("./dark-texture-watercolor.jpg"),
//   flower: require("./flower.png"),
//   appleLogo: require("./apple-logo.png"),
//   googleLogo: require("./google-logo.png"),
//   gMapsLogo: require("./gmaps-logo.png"),
//   wazeLogo: require("./waze-logo.png"),
//   song: {
//     stillLife: require("./bigbang-still-life.mp3"),
//   },
// };

export const assets = {
  frame3: require("./frame3.png"),
  strokeGold: require("./stroke-gold.png"),
  appleLogo: require("../assets/apple-logo.png"),
  googleLogo: require("../assets/google-logo.png"),
  gMapsLogo: require("../assets/gmaps-logo.png"),
  wazeLogo: require("../assets/waze-logo.png"),
  marbleBg: require("../assets/marble-bg.jpeg"),
  invBg: require("../assets/inv-bg.jpeg"),
  geoFrame: require("./geo-frame.png"),
  bismillah: require("./bismillah.png"),
  leavesNormal: require("./leaves2-normal.png"),
  song: {
    bgMusic:
      "https://firebasestorage.googleapis.com/v0/b/fadhil-wedding.appspot.com/o/assets%2Fbigbang-still-life.mp3?alt=media&token=be9bde07-6a36-45d8-842c-b23f2223fc5b",
  },
};

// export const assets = {
//   frame1:
//     "https://firebasestorage.googleapis.com/v0/b/fadhil-wedding.appspot.com/o/assets%2Fframe1.png?alt=media&token=f9f6f316-0ad3-4715-aced-08b59edd7934",
//   frame3: require("./frame3.png"),
//   strokeGold: require("./stroke-gold.png"),
//   appleLogo:
//     "https://firebasestorage.googleapis.com/v0/b/fadhil-wedding.appspot.com/o/assets%2Fapple-logo.png?alt=media&token=c01aef77-25b6-43e8-b837-08c8d90a6f90",
//   googleLogo:
//     "https://firebasestorage.googleapis.com/v0/b/fadhil-wedding.appspot.com/o/assets%2Fgoogle-logo.png?alt=media&token=93a8b243-7511-41f3-8892-f9c262977819",
//   gMapsLogo:
//     "https://firebasestorage.googleapis.com/v0/b/fadhil-wedding.appspot.com/o/assets%2Fgmaps-logo.png?alt=media&token=88c6b887-5288-4b26-a3b4-123de3a0c5be",
//   wazeLogo:
//     "https://firebasestorage.googleapis.com/v0/b/fadhil-wedding.appspot.com/o/assets%2Fwaze-logo.png?alt=media&token=209984de-c8d3-4b4c-b61d-ecb6dd3d9316",
//   marbleBg:
//     "https://firebasestorage.googleapis.com/v0/b/fadhil-wedding.appspot.com/o/assets%2Fmarble-bg.jpeg?alt=media&token=e79322ce-cc42-4dfe-ac6c-8323088dcf06",
//   invBg:
//     "https://firebasestorage.googleapis.com/v0/b/fadhil-wedding.appspot.com/o/assets%2Finv-bg.jpeg?alt=media&token=8e65cd0a-e907-406a-87d8-192aaafc6a82",
//   geoFrame: require("./geo-frame.png"),
//   bismillah: require("./bismillah.png"),
//   leavesNormal: require("./leaves2-normal.png"),
//   song: {
//     stillLife:
//       "https://firebasestorage.googleapis.com/v0/b/fadhil-wedding.appspot.com/o/assets%2Fbigbang-still-life.mp3?alt=media&token=be9bde07-6a36-45d8-842c-b23f2223fc5b",
//   },
// };
